




































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Moment from 'moment';
import { DisputeReport } from 'frontend/types/daily-challenges';

@Component({})
export default class DailyChallengeDisputes extends Vue {
  @Prop(Array) private disputes!: DisputeReport[];

  private timeAgo(ts: number) {
    return Moment(ts).fromNow();
  }
}
